import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./i18n";
import "./primereactPatches";
import UserProvider from "./contexts/User";
import ChatProvider from "./contexts/Messages";
import AppointmentReportProvider from "./contexts/AppointmentReport";
import SurveyAndCheckInsProvider from "./contexts/SurveyAndCheckIns";
import NavigationBlockerProvider from "./contexts/NavigationBlocker";
import AdminApp from "./_admin";

// ***** PrimeReact *****
import "primereact/resources/themes/tailwind-light/theme.css"; // Theme : tailwind-light
import "primereact/resources/primereact.min.css"; // PrimeReact Core css
import "primeicons/primeicons.css"; // PrimeReact Icons
import { PrimeReactProvider } from "primereact/api";

import { AbilityContext } from "ability/Can";
import { ability } from "ability/ability";
import GlobalChatProvider from "@contexts/GlobalMessages";

const primeReactConfig = {
  ripple: true,
  inputStyle: "outlined",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

if (process.env.REACT_APP_TYPE === "admin") {
  root.render(<AdminApp />);
} else {
  // Compose the element tree for the main app route
  const MainAppElement = (
    <ErrorBoundary>
      <AbilityContext.Provider value={ability}>
        <PrimeReactProvider value={primeReactConfig}>
          <UserProvider>
            <AppointmentReportProvider>
              <NavigationBlockerProvider>
                <ChatProvider>
                  <GlobalChatProvider>
                    <SurveyAndCheckInsProvider>
                      <App />
                    </SurveyAndCheckInsProvider>
                  </GlobalChatProvider>
                </ChatProvider>
              </NavigationBlockerProvider>
            </AppointmentReportProvider>
          </UserProvider>
        </PrimeReactProvider>
      </AbilityContext.Provider>
    </ErrorBoundary>
  );

  // Define routes for the data router
  const router = createBrowserRouter([
    {
      path: "*",
      element: MainAppElement,
    },
  ]);

  root.render(<RouterProvider router={router} />);
}
